module.exports = __webpack_public_path__ + "img/MEDIA070.7a976eba.jpg";